/** Ancho máximo del logo en píxeles (~203 DPI en papel 80 mm). */
export const TICKET_LOGO_MAX_WIDTH = 384;

const LUMINANCE_THRESHOLD = 128;

function luminance(r, g, b) {
    return 0.299 * r + 0.587 * g + 0.114 * b;
}

/**
 * Convierte Image/canvas a PNG blanco y negro puro (sin grises) para impresora térmica.
 */
export function canvasToThermalPng(source, maxWidth = TICKET_LOGO_MAX_WIDTH) {
    const sw = source.naturalWidth || source.width;
    const sh = source.naturalHeight || source.height;
    if (!sw || !sh) {
        throw new Error("Imagen sin dimensiones");
    }
    const scale = Math.min(1, maxWidth / sw);
    const w = Math.max(1, Math.round(sw * scale));
    const h = Math.max(1, Math.round(sh * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(source, 0, 0, w, h);
    const imageData = ctx.getImageData(0, 0, w, h);
    const d = imageData.data;
    for (let i = 0; i < d.length; i += 4) {
        const black = luminance(d[i], d[i + 1], d[i + 2]) < LUMINANCE_THRESHOLD;
        d[i] = d[i + 1] = d[i + 2] = black ? 0 : 255;
        d[i + 3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL("image/png");
}

/** Procesa data URL existente (logos guardados en Mongo) antes de imprimir. */
export function prepareLogoForThermal(dataUrl, maxWidth = TICKET_LOGO_MAX_WIDTH) {
    const src = (dataUrl || "").trim();
    if (!src) return Promise.resolve("");
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            try {
                resolve(canvasToThermalPng(img, maxWidth));
            } catch (e) {
                reject(e);
            }
        };
        img.onerror = () => reject(new Error("No se pudo procesar el logo"));
        img.src = src;
    });
}

/** Redimensiona archivo de logo a PNG B/N para ticket térmico. */
export function processImageFileForTicket(file, maxWidth = TICKET_LOGO_MAX_WIDTH) {
    return new Promise((resolve, reject) => {
        if (!file?.type?.startsWith("image/")) {
            reject(new Error("Selecciona un archivo de imagen"));
            return;
        }
        const reader = new FileReader();
        reader.onload = (ev) => {
            const img = new Image();
            img.onload = () => {
                try {
                    resolve(canvasToThermalPng(img, maxWidth));
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = () => reject(new Error("No se pudo leer la imagen"));
            img.src = ev.target.result;
        };
        reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
        reader.readAsDataURL(file);
    });
}
